// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2cW28","item":"PaymentsMobile_item__E_VLZ","label":"PaymentsMobile_label__2zIUk","amount":"PaymentsMobile_amount__2n82a"};